export enum ProcessStatus {
  Import = 1,
  Processed,
  Cancelled
}

export namespace ProcessStatus {
  export function values() {
    return Object.keys(ProcessStatus).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
